import { NetworkStatus } from '@apollo/client'

import {
  GetAnnotationsQueryVariables,
  useGetAnnotationsQuery,
  useGetPreviewAnnotationsQuery,
} from '@sketch/gql-types'
import { usePreview } from '../../shares/views/PreviewView/PreviewContext'

interface UseGetAnnotationsProps {
  skip?: boolean
  variables: GetAnnotationsQueryVariables
}

const loadingStatus = [NetworkStatus.loading, NetworkStatus.setVariables]

const useGetAnnotations = ({ skip, variables }: UseGetAnnotationsProps) => {
  const previewContext = usePreview()
  const isPreview = !!previewContext

  const queryRegular = useGetAnnotationsQuery({
    variables,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: skip || isPreview,
    shouldInvalidatePrevious: (prev, curr) =>
      prev?.versionIdentifier !== curr?.versionIdentifier ||
      prev?.annotationStatus !== curr?.annotationStatus ||
      prev?.sort !== curr?.sort,
  })

  const queryPreview = useGetPreviewAnnotationsQuery({
    variables: {
      ...variables,
      previewIdentifier: previewContext?.preview.identifier || '',
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: skip || !isPreview,
    shouldInvalidatePrevious: (prev, curr) =>
      prev?.previewIdentifier !== curr?.previewIdentifier ||
      prev?.status !== curr?.status ||
      prev?.sortOrder !== curr?.sortOrder,
  })

  const query = isPreview ? queryPreview : queryRegular

  return {
    ...query,
    /* Only turn on loading state at initial load or when the `versionIdentifier` changes */
    loading: loadingStatus.includes(query.networkStatus) && !query.data,
  }
}

export default useGetAnnotations
